module.exports = __webpack_public_path__ + "static/img/7.d9692de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/7.png
// module id = BesO
// module chunks = 35